import {showNotification} from "@mantine/notifications";
import {
    AiOutlineExclamation,
    AiOutlineInfo
} from "react-icons/ai";
import {signInWithRedirect} from "aws-amplify/auth";


export const notifySuccess = (message = 'Record saved successfully') => {
    showNotification({
                         title: 'Success',
                         icon: <AiOutlineInfo/>,
                         message: message,
                         color: 'teal',
                     })
}

export const notifyError = (e: unknown = 'Error performing the operation') => {
    let err: { message: string; errors?: { message: string }[] };
    if (typeof e === 'string') {
        err = {message: e};
    } else {
        err = e as { message: string; errors?: { message: string }[] };
    }

    if (typeof err.errors !== 'undefined' && err.errors.length > 0) {
        err.errors.forEach((error: { message: string; }) => {

            showNotification({
                                 title: 'Error',
                                 icon: <AiOutlineExclamation/>,
                                 message: error.message,
                                 color: 'red',
                             })


        })
    } else {

        showNotification({
                             title: 'Error',
                             icon: <AiOutlineExclamation/>,
                             message: err.message,
                             color: 'red',
                         })

    }

    if (err.message.toLowerCase() === 'no federated jwt') {
        signInWithRedirect()
    }

}

